(() => {
  const tip = document.querySelector('[data-nekas-orientation-tip]');
  const continueButton = tip?.querySelector('[data-nekas-orientation-continue]');

  if (!tip || !continueButton) return;

  document.body.appendChild(tip);

  const storageKey = 'nekasLandscapeTipSeenV1';
  const portraitQuery = window.matchMedia('(max-width: 749px) and (orientation: portrait)');
  let initialReady = false;
  let shownThisPage = false;
  let rememberedByThisView = false;
  let previousFocus = null;
  let cookieObserver = null;
  let observerActive = false;

  const readSeen = () => {
    try {
      return window.localStorage.getItem(storageKey) === '1';
    } catch (error) {
      return shownThisPage;
    }
  };

  const rememberSeen = () => {
    shownThisPage = true;
    rememberedByThisView = true;

    try {
      window.localStorage.setItem(storageKey, '1');
    } catch (error) {
      /* The in-memory flag still prevents repeats during this page view. */
    }
  };

  const forgetInterruptedView = () => {
    if (!rememberedByThisView) return;

    shownThisPage = false;
    rememberedByThisView = false;

    try {
      window.localStorage.removeItem(storageKey);
    } catch (error) {
      /* Storage may be unavailable; the in-memory value is already reset. */
    }
  };

  const isVisible = (element) => {
    if (!element || element.hidden || element.getAttribute('aria-hidden') === 'true') return false;
    if (element.closest('[hidden], [aria-hidden="true"]')) return false;

    const style = window.getComputedStyle(element);
    return style.display !== 'none' && style.visibility !== 'hidden' && element.getClientRects().length > 0;
  };

  const cookieChoiceIsOpen = () => {
    const banner = document.querySelector('#shopify-pc__banner, .shopify-pc__banner__dialog');
    const preferences = document.querySelector('#shopify-pc__prefs__dialog');

    if (isVisible(banner) || isVisible(preferences)) return true;

    try {
      return window.Shopify?.customerPrivacy?.shouldShowBanner?.() === true;
    } catch (error) {
      return false;
    }
  };

  const stopCookieObserver = () => {
    cookieObserver?.disconnect();
    observerActive = false;
  };

  const restoreFocus = () => {
    if (previousFocus instanceof HTMLElement && previousFocus.isConnected) {
      previousFocus.focus({ preventScroll: true });
      return;
    }

    const main = document.querySelector('#MainContent, main');
    if (main instanceof HTMLElement) main.focus({ preventScroll: true });
  };

  const hideTip = ({ restore = true, interrupted = false } = {}) => {
    if (tip.hidden) return;

    tip.hidden = true;
    document.documentElement.classList.remove('nekas-orientation-tip-open');

    if (interrupted) forgetInterruptedView();
    if (!interrupted) stopCookieObserver();
    if (restore) restoreFocus();
  };

  const showTip = () => {
    if (!initialReady || !portraitQuery.matches || readSeen() || cookieChoiceIsOpen()) return false;

    previousFocus = document.activeElement;
    rememberSeen();
    tip.hidden = false;
    document.documentElement.classList.add('nekas-orientation-tip-open');
    window.requestAnimationFrame(() => continueButton.focus({ preventScroll: true }));
    return true;
  };

  const maybeShowTip = () => {
    if (!initialReady || readSeen() || !portraitQuery.matches || cookieChoiceIsOpen()) return;
    showTip();
  };

  continueButton.addEventListener('click', () => hideTip());

  tip.addEventListener('click', (event) => {
    if (event.target === tip) hideTip();
  });

  document.addEventListener('keydown', (event) => {
    if (tip.hidden) return;

    if (event.key === 'Escape') {
      event.preventDefault();
      hideTip();
      return;
    }

    if (event.key === 'Tab') {
      event.preventDefault();
      continueButton.focus({ preventScroll: true });
    }
  });

  const handleViewportChange = () => {
    if (!portraitQuery.matches) {
      if (tip.hidden) {
        stopCookieObserver();
      } else {
        hideTip();
      }
      return;
    }

    startCookieObserver();
    maybeShowTip();
  };

  if (portraitQuery.addEventListener) {
    portraitQuery.addEventListener('change', handleViewportChange);
  } else {
    portraitQuery.addListener(handleViewportChange);
  }

  document.addEventListener('visitorConsentCollected', () => {
    window.setTimeout(maybeShowTip, 150);
    window.setTimeout(maybeShowTip, 650);
    window.setTimeout(maybeShowTip, 1400);
  });

  cookieObserver = new MutationObserver(() => {
    if (!tip.hidden && cookieChoiceIsOpen()) {
      hideTip({ restore: false, interrupted: true });
      return;
    }

    if (initialReady) maybeShowTip();
  });

  const startCookieObserver = () => {
    if (observerActive || readSeen() || !portraitQuery.matches) return;

    cookieObserver.observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'hidden', 'open', 'style', 'aria-hidden']
    });
    observerActive = true;
  };

  startCookieObserver();

  window.setTimeout(() => {
    initialReady = true;
    maybeShowTip();
  }, 1400);

  window.addEventListener('pagehide', () => {
    if (!tip.hidden) hideTip({ restore: false });
    stopCookieObserver();
  });

  window.addEventListener('pageshow', (event) => {
    if (!event.persisted || readSeen()) return;
    startCookieObserver();
    maybeShowTip();
  });
})();
